import axios from 'axios';
import API_URL from '../../config';

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

export const saveSeparation = async (separationData, action = "SAVE") => {
    try {
        const response = await axios.post(`${API_URL}/api/EmployeeSeparation/save`, {
            action: action,
            separation: separationData
        }, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        console.error('Error saving employee separation:', error);
        throw error.response?.data || error.message;
    }
};

export const getSeparationList = async (filter = {}) => {
    try {
        const response = await axios.post(`${API_URL}/api/EmployeeSeparation/list`, filter, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching separation list:', error);
        throw error.response?.data || error.message;
    }
};

export const getSeparationById = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/EmployeeSeparation/${id}`, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching separation by ID:', error);
        throw error.response?.data || error.message;
    }
};

export const getSeparationReasons = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/EmployeeSeparation/reasons`, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching separation reasons:', error);
        throw error.response?.data || error.message;
    }
};

export const calculateGratuity = async (employeeId) => {
    try {
        const response = await axios.get(`${API_URL}/api/EmployeeSeparation/calculate-gratuity/${employeeId}`, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        console.error('Error calculating gratuity:', error);
        throw error.response?.data || error.message;
    }
};
